module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-form-feedback"
  }, [_c('div', {
    staticClass: "page"
  }, [(_vm.privateForm) ? _c('div', [_c('p', {
    staticStyle: {
      "padding-top": "0.71rem"
    }
  }, [_vm._v("共收集了"), _c('span', {
    staticClass: "lxm-form-feedback__summary-number"
  }, [_vm._v(_vm._s(_vm.state.count))]), _vm._v("份反馈")]), _vm._v(" "), _c('p', {
    staticClass: "private_form"
  }, [_vm._v("该表单为“私密表单”，请联系表单创建人申请权限查看反馈详情")])]) : _c('div', [_c('lxm-switch-search', {
    attrs: {
      "searchPlaceholder": '姓名'
    },
    on: {
      "submit": _vm.searchSubmit,
      "end": _vm.searchEnded
    }
  }, [_vm._v("\n        共收集了"), _c('span', {
    staticClass: "lxm-form-feedback__summary-number"
  }, [_vm._v(_vm._s(_vm.state.count))]), _vm._v("份反馈\n      ")]), _vm._v(" "), _c('lxm-table', {
    attrs: {
      "heads": _vm.tableHeads,
      "rows": _vm.tableRows,
      "tos": _vm.tableTos
    }
  }), _vm._v(" "), (_vm.state.hasMore) ? _c('lxm-more', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.moreClicked
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e4cc6548", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e4cc6548!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Form/Feedback.vue
// module id = 891
// module chunks = 0